import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTheme } from 'src/hooks';

export const JobOpeningCard = ({ description, previewImage, slug, title }) => {
  const { navigation, global } = useTheme();

  return (
    <Link to={`/${navigation.job.path}/${slug.current}`}>
      <Container className="border-dusk shadow-card-darker bg-dark bg-shapes-job-card rounded-xl border">
        <Row>
          <Col xs={12} md={7} className="p-xl-6 p-3">
            <Col className="mb-4 px-0">
              <h3 className="h4 text-white">{title}</h3>
            </Col>
            <Col className="mb-4 px-0 text-white">{description}</Col>
            <Col className="px-0">
              <div className="btn-link-secondary mt-4">{global.more}</div>
            </Col>
          </Col>
          <Col className="d-none d-md-block align-items-center py-2" md={5}>
            <GatsbyImage
              image={previewImage.image.asset.gatsbyImageData}
              alt={previewImage.alt}
              objectFit="contain"
              style={{ maxHeight: '300px' }}
            />
          </Col>
        </Row>
      </Container>
    </Link>
  );
};
